 import React, { FC } from 'react';
import styled, { css } from 'src/theme';

import SVG from 'react-inlinesvg';

interface SVGProps {
  color: string;
}

export interface Step {
  icon: string;
  color: 'empty' | 'filled';
  text: string;
}

interface Props extends Step {
  className?: string;
  onClick?: () => void;
  disabled: boolean;
}

export const StepButton: FC<Props> = ({ color = 'empty', ...props }) => (
  <StepStyled>
    <ButtonStyled
      className={props.className}
      color={color}
      onClick={props.onClick}
      disabled={!props.disabled}
    >

      <StyledSVG color={color} src={props.icon} />
    </ButtonStyled>

    <TextStyled>
      {props.text}
    </TextStyled>
  </StepStyled>
);


const StepStyled = styled.div`
  width: min-content;
`;

const TextStyled = styled.span`
  position: absolute;
  width: 70px;
  margin-top: 5px;
  font-size: 13px;
  color: ${props => props.theme.colors.nero};
  @media screen and ${props => props.theme.media.tablet} {
    width: 65px;
    font-size: 12px;
  }
  @media screen and ${props => props.theme.media.mobile} {
    width: 50px;
    font-size: 10px;
  }
`;

const ButtonStyled = styled.button<{ color: Props['color'] }>`
  ${(props) => css`
    display: flex;
    justify-content: center;
    align-items: center;
    background: ${props.color === 'filled' ? props.theme.colors.orange : props.theme.colors.white};
    width: 50px;
    height: 50px;
    padding: 0;
    border-radius: 50%;
    border: 2px solid ${props => props.theme.colors.orange};

    &:disabled {
      cursor: text;
    }
    @media screen and ${props.theme.media.tablet} {
      width: 40px;
      height: 40px;
    }
    @media screen and ${props.theme.media.mobile} {
      width: 30px;
      height: 30px;
    }
    
  `}
`;

const StyledSVG = styled(SVG)<SVGProps>`
  ${(props) => css`
    width: 30px;
    height: 30px;
    & path {
      fill: ${props.color === 'filled' ? props.theme.colors.white : props.theme.colors.black};
    }
    @media screen and ${props.theme.media.tablet} {
      width: 25px;
      height: 25px;
    }
    @media screen and ${props.theme.media.mobile} {
      width: 20px;
      height: 20px;
    }
  `};
`;
